import Swiper, { Navigation, Pagination, Autoplay } from 'swiper';
import AOS from 'aos';

import {Header} from '../util/header';
import {Accordeon} from '../util/accordeon';
import {AnimatedCounters} from '../scripts/AnimatedCounter';
import {Slider} from '../scripts/Slider';

export default {
  init() {
    new Header()
    new Accordeon()
    new AnimatedCounters()
    new Slider(Swiper, [Navigation, Pagination, Autoplay])

    AOS.init()
    AOS.refresh()

  },
  finalize() {
  },
};



// WEBPACK FOOTER //
// ./js/routes/common.js